export function cloneObject<T>(o: T): T {
	if (typeof structuredClone === 'function') {
		try {
			return structuredClone(o);
		} catch {
			// falls through to JSON clone below
		}
	}
	try {
		return JSON.parse(JSON.stringify(o));
	} catch {
		return o;
	}
}
